import { createSelector } from 'reselect';
import checkFeatureFlag from 'utils/featureFlags';
import { selectIsCreditScoreAvailable } from 'features/credit-score/selectors';
import { selectIsWalkthroughInactive } from 'features/feed/selectors';
import { selectRemovePayTab } from 'features/pay/selectors';
import { selectIsGBUser, selectPasscodeVisible } from '../selectors';
import { selectTabsPriority } from './organiseTabs';
import { isWeb } from '../../constants';
export const selectIsInvestWalkthroughActive = (store) => store.walkthrough.investWalkthrough?.status === 'in-progress';
export const selectInvestWalkthroughStep = (store) => store.walkthrough.investWalkthrough?.step || 0;
export const selectIsEmmaWalkthroughActive = (store) => store.feed.walkthrough?.status === 'in-progress';
export const selectShowWalkthroughV6 = createSelector([(store) => store.utils.featureFlags, selectIsGBUser], (featureFlags, isGBUser) => !!(isGBUser && checkFeatureFlag(featureFlags, 'walkthrough_v6_v2')));
export const selectIsCreditScoreSpotlightActive = createSelector([
    selectIsCreditScoreAvailable,
    selectIsWalkthroughInactive,
    selectIsInvestWalkthroughActive,
    selectTabsPriority,
    (store) => store.utils.currentScreen,
    (store) => store.deviceSettings.didSeeCreditScoreSpotlight,
    selectPasscodeVisible,
], (isCreditScoreAvailable, isWalkthroughInactive, isInvestWalkthroughActive, { priority }, currentScreen, didSee, isPasscodeVisible) => {
    const borrowIndex = priority.indexOf('borrow');
    const tabIndex = borrowIndex >= 0 ? borrowIndex + 1 : -1;
    const isOnFeed = !currentScreen ||
        currentScreen === 'Feed' ||
        currentScreen === 'Main' ||
        currentScreen === 'MainStack';
    return (!isWeb &&
        tabIndex >= 0 &&
        isCreditScoreAvailable &&
        isWalkthroughInactive &&
        !isInvestWalkthroughActive &&
        isOnFeed &&
        !isPasscodeVisible &&
        !didSee);
});
export const selectIsPayFeedSpotlightActive = createSelector([
    selectRemovePayTab,
    selectIsWalkthroughInactive,
    selectIsInvestWalkthroughActive,
    selectIsCreditScoreSpotlightActive,
    (store) => store.utils.currentScreen,
    (store) => store.deviceSettings.didSeePayFeedSpotlight,
    selectPasscodeVisible,
    (store) => store.feed.feed?.cards,
], (removePayTab, isWalkthroughInactive, isInvestWalkthroughActive, isCreditScoreSpotlightActive, currentScreen, didSee, isPasscodeVisible, feedCards) => {
    const isOnFeed = !currentScreen ||
        currentScreen === 'Feed' ||
        currentScreen === 'Main' ||
        currentScreen === 'MainStack';
    // the dismissal UI mounts inside the populated Feed, so never activate the
    // (touch-blocking) overlays while Feed renders NoContentFeed or a loader
    const hasFeedContent = !!feedCards && Object.keys(feedCards).length > 0;
    return (!isWeb &&
        removePayTab &&
        hasFeedContent &&
        isWalkthroughInactive &&
        !isInvestWalkthroughActive &&
        // queue behind the credit score spotlight rather than stacking
        !isCreditScoreSpotlightActive &&
        isOnFeed &&
        !isPasscodeVisible &&
        !didSee);
});
